export function createAuthUseCases({ getFirebase, dataSource }) {
  return {
    async loginConGoogle() {
      const { auth } = getFirebase();
      return dataSource.signInWithGoogle(auth);
    },
  };
}
